import { ObservableFromFetch } from "../ObservableFromFetch"
import SearchField from "../SearchField"

export const SearchFieldsGet = () => ObservableFromFetch<SearchField[]>("RandomTest/GetEventSearchDropdowns")